/** Length in Unicode code points (the unit every server limit uses), not UTF-16 units. */
export const codePointLength = (s: string): number => Array.from(s).length;

/** The first `max` code points of `s` + "…" when it is longer; never splits a surrogate pair. */
export function truncateCodePoints(s: string, max: number): string {
  const cps = Array.from(s);
  return cps.length > max ? cps.slice(0, max).join("") + "…" : s;
}
